import { booleanAttribute, Component, input } from '@angular/core';
import { ScribeSuggestionIndicatorComponent } from '../shared/scribe-suggestion-indicator/scribe-suggestion-indicator.component';
import { AmendmentFieldIndicatorComponent } from '../shared/amendment-field-indicator/amendment-field-indicator.component';
import { ScribeSuggestionMarkerTarget } from '../../scribe-suggestion-marker.model';

/**
 * Display-only select for previews and read-only layouts.
 */
@Component({
  selector: 'fb-select-display',
  imports: [ScribeSuggestionIndicatorComponent, AmendmentFieldIndicatorComponent],
  templateUrl: './select-display.html',
  styleUrl: './select-display.scss',
  host: { '[attr.data-muted]': 'muted()' },
})
export class SelectDisplay {
  /**
   * A text that describes the purpose of the select.
   */
  public readonly label = input.required();

  /**
   * Placeholder text shown when {@link text} is empty.
   */
  public readonly placeholder = input('');

  /**
   * Enables muted (grayed-out) visual styling.
   */
  public readonly muted = input(false, { transform: booleanAttribute });

  /**
   * The text to display.
   */
  public readonly text = input('');

  /**
   * Whether the placeholder should be rendered when the field is empty.
   */
  public readonly showPlaceholder = input(true, { transform: booleanAttribute });
  public readonly markerTarget = input<ScribeSuggestionMarkerTarget | null>(null);
  /**
   * Index of the treatment row this field belongs to, for the amendment indicator.
   */
  public readonly rowIndex = input<number | null>(null);
  public readonly markerFieldKey = input<string>();
}
